/**
 * Construye un array de columnas para una tabla de Antd, fusionando la configuración base
 * con la configuración específica de cada columna, excluyendo los campos marcados
 * con showColumn=false. Además, se agrega automáticamente una clave única (key) a cada columna
 * si no se establece explícitamente en la configuración.
 * 
 * @param {Array} columnsConfig Array de objetos con configuraciones de las columnas.
 * @param {boolean} [columnsConfig.showColumn] Indica si la columna se debe mostrar.
 * @param {Object} [baseColumnConfig] Objeto con configuraciones comunes en todas las columnas.
 * @returns {Array} Un array de objetos que representan las columnas de la tabla.
 */
export const buildColumns = (columnsConfig, baseColumnConfig) =>
  columnsConfig
    .filter(config => config.showColumn !== false)
    .map(({ key, showColumn, ...restConfig }, index) => {
      // Se desestructura la configuración omitiendo showColumn
      const columnKey = key ?? restConfig.dataIndex ?? (typeof restConfig.title === 'string' ? restConfig.title : `column_${index}`);

      return {
        ...baseColumnConfig,
        ...restConfig,
        key: columnKey,
      };
    });